const ImageLocations = {
  hero: 'hero',
  overview: 'overview',
  siteHeader: 'site-header',
  siteFooter: 'site-footer'
};

export default ImageLocations;
